<div class="px-plus ty-75">
  <common-ui-components-title-summary
    [title]="'معرفی فروشگاه'"
    [showButton]="true"
    [mustReturnAction]="true"
    [buttonIconReversed]="true"
    [buttonTrackerId]="'shopping-guide'"
    [buttonTitle]="'راهنمای خرید'"
    [buttonIcon]="'question-mark-circle'"
    (onButtonClicked)="goToShoppingGuide()"
    [wrapperClasses]="'mb-small'"
  ></common-ui-components-title-summary>
  <span
    class="c-3 text-onback-medium text-align-right store-description"
    [innerHTML]="store()?.description"
  ></span>
  <div class="d-flex gap-low flex-wrap mt-medium">
    @for (category of store()?.productCategories; track category) {
      <div class="chips radius-giant surface-back px-small py-tiny c-2 text-onback-medium">{{ category }}</div>
    }
  </div>
  @if (vouchers() && vouchers()?.length) {
    <div class="my-big">
      @for (voucher of vouchers(); track voucher.code) {
        <div class="mt-pony">
          <common-ui-components-discount-tag
            [title]="voucher.description!"
            [code]="voucher.code!"
          ></common-ui-components-discount-tag>
        </div>
      }
    </div>
  }

  @if (store()?.trackingCode) {
    <stores-applet-addresses [storeTrackingCode]="store().trackingCode"></stores-applet-addresses>
  }
</div>
